import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PayService } from 'src/app/service/pay.service';

function passwordMatchValidator(g: UntypedFormGroup) {
  return g.get('password').value === g.get('confirmPassword').value
    ? null : { 'mismatch': true };
}
@Component({
    selector: 'app-ajouter-spay',
    templateUrl: './ajouter-spay.component.html',
    styleUrls: ['./ajouter-spay.component.css'],
    standalone: false
})
export class AjouterSpayComponent implements OnInit {
  partenaireForm: UntypedFormGroup;
  softPayOperatorList: any[] = [];
  isEdit: boolean=false;
  accountid: any;
  update: boolean=false;

  constructor(private userService: PayService) { }

  ngOnInit(): void 
  {
    this.ngpartenaireForm();
    this.findSoftPayOperators();
  }


  ngpartenaireForm() {
    this.partenaireForm = new UntypedFormGroup({
      firstName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      lastName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      email: new UntypedFormControl('', [Validators.required, Validators.pattern("[^ @]*@[^ @]*[.][^ @]{2,}")]),
      phone: new UntypedFormControl('', [Validators.required, Validators.pattern("[1-9][0-9]*"), Validators.pattern('(^(65)[0-9]{1}[0-9]{6}|^(69|66|67|64)[0-9]{7})$')]),
      password: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]{6}')]),
      confirmPassword: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]{6}')]),
      quartier:new UntypedFormControl('', [Validators.required]),
      nidentification:new UntypedFormControl('', [Validators.required]),
      etsbancaire:new UntypedFormControl('', [Validators.required]),
      ville:new UntypedFormControl('', [Validators.required])
    }, passwordMatchValidator)
  }
  editPartenaire(p)
  {
    this.partenaireForm.get("firstName").setValue(p.firstName);
    this.partenaireForm.get("lastName").setValue(p.lastName) 
    this.partenaireForm.get("email").setValue(p.username) 
    this.partenaireForm.get("phone").setValue(p.phone) 
    this.partenaireForm.get("quartier").setValue(p.quartier) 
    this.partenaireForm.get("nidentification").setValue(p.nidentification) 
    this.partenaireForm.get("etsbancaire").setValue(p.etsbancaire) 
    this.partenaireForm.get("ville").setValue(p.ville) 
    this.isEdit=true;
    this.accountid=p.id;
  }

  addpartenaire(formdata)
  {
    if(this.isEdit)
    {
      this.userService.updatesoftPayaccount(this.accountid,formdata).subscribe(data=>{
        if(data==0)
        {
          this.update=true;
          setTimeout(() => {
            this.update=false;
          }, 2000);
        }
      })
    }
    else{
      this.userService.ajouterSoftPayaccount(formdata).subscribe(data=>{
       
        this.findSoftPayOperators();
        })
    }
   

  }

  findSoftPayOperators()
  {
    this.userService.getSoftPayOperators().subscribe((data:any[])=>{
      this.softPayOperatorList = data || [];
      
    })
  }

 


}
